export class BrokerActivityReportColumnMap {
	public colText: string;
	public colValue: string;

	constructor(text: string, value: string) {
		this.colText = text;
		this.colValue = value;
	}
}
